module.exports = __webpack_public_path__ + "static/media/icon-especialista.485d48c1.svg";